<template>
  <div class="mt16">
    <div class="login-message-banner col-sm-12">
      <div
        class="login-message-item pr20 pl12 flex-row mb16 shimmer-container"
      ></div>
    </div>
    <div class="order-type-wrap line-btn sm mb16 shimmer-container">
      <div class="order-type-btn btn-1 color-slaty shimmer-container"></div>
    </div>
    <div
      class="col-sm-12 pers-offers-wrap pl0 carousel-pr-12 pr0"
      data-offers="null"
    >
      <div
        class="shimmer-container mr12 ml12 fs-14 bold lh20 mb8 pl12 rounded"
        style="max-width: 210px; min-height: 20px"
      ></div>
      <section class="carousel" dir="ltr" aria-label="Gallery">
        <div class="carousel__viewport">
          <ol
            class="carousel__track"
            style="transform: translateX(0px); transition: all 0ms ease 0s"
          >
            <li
              class="carousel__slide carousel__slide--active carousel__slide--visible"
              style="width: 57.1429%; order: 0"
            >
              <div
                class="pers-offer flex-row shimmer-container"
                style="width: 300px"
              >
                <!-- <div class="observer"></div>
                <div>
                    <div class="fs-14 lh-20 bold offer-title disp-col-inline">
                        <i class="jfi-offer-tag mr8 jfi-offers-v2"></i>
                        <span class="three-dot">Flat Rs.100 OFF</span>
                    </div>
                    <div class="fs-12 lh-18 offer-desc three-dot">BIN coupon fully funded by bank</div>
                </div> -->
                <!-- <button class="line-btn sm"> Apply </button> -->
              </div>
            </li>
            <li
              class="carousel__slide carousel__slide--next"
              style="width: 57.1429%; order: 1"
            >
              <div
                class="milestone-offer flex-row shimmer-container"
                style="width: 300px"
              >
                <!-- <div class="observer"></div>
                <div>
                    <ul class="fs-14 bold disp-col-inline ms-timeline">
                        <li class=""><div class="bold order-no">1st Order </div><div class="fs-10 bold three-dot ms-title">40% Off</div><div class="border-arrow-img"></div></li>
                        <li class=""><div class="bold order-no">2nd Order </div><div class="fs-10 bold three-dot ms-title">30% Off</div><div class="border-arrow-img"></div></li>
                        <li class=""><div class="bold order-no">3rd Order </div><div class="fs-10 bold three-dot ms-title">50% Off</div><div class="border-arrow-img"></div></li>
                    </ul>
                </div><button class="line-btn sm"> Apply </button> -->
              </div>
            </li>
            <li class="carousel__slide" style="width: 57.1429%; order: 2">
              <div
                class="pers-offer flex-row shimmer-container"
                style="width: 300px"
              >
                <!-- <div class="observer"></div>
                <div><div class="fs-14 lh-20 bold offer-title disp-col-inline"><i class="jfi-offer-tag mr8 jfi-offers-v2"></i><span class="three-dot">Something off</span></div><div class="fs-12 lh-18 offer-desc three-dot">Coupon for discount</div>
                </div><button class="line-btn sm"> Apply </button> -->
              </div>
            </li>
            <li class="carousel__slide" style="width: 57.1429%; order: 3">
              <div
                class="pers-offer flex-row shimmer-container"
                style="width: 300px"
              >
                <!-- <div class="observer"></div><div><div class="fs-14 lh-20 bold offer-title disp-col-inline"><i class="jfi-offer-tag mr8 jfi-offers-v2"></i><span class="three-dot">testCodeS3</span></div><div class="fs-12 lh-18 offer-desc three-dot">testCodeS3 desc</div></div><button class="line-btn sm"> Apply </button> -->
              </div>
            </li>
          </ol>
        </div>
      </section>
      <!-- Milestone/tnc unapplied state popup shown on banner click --><!-- Offer Appplied popup --><!-- offer not applied msg modal --><!-- @@Display Error Msg of non applied Coupon --><!-- <generic-modal
      v-if="showOfferNotApplied"
      :height="msModalDim.height"
      :width="msModalDim.width"
      :animationStyle="msModalDim.animationStyle"
    >
      <template v-slot:header>
        <div class="bold fs-18">
        </div>
      </template>
      <template v-slot:body>
        <div class="">
          <p class="fs-16 lh20 error-msg pTB24 mb20">
            {{ offerFailedMsg }}
          </p>
        </div>
      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal> -->
    </div>
    <div class="horizontal-menu mb15 pr0 col-sm-12 pl0 carousel-pr-12">
      <section class="carousel" dir="ltr" aria-label="Gallery">
        <div class="carousel__viewport">
          <ol
            class="carousel__track"
            style="transform: translateX(0px); transition: all 0ms ease 0s"
          >
            <li
              class="carousel__slide carousel__slide--visible"
              style="width: 28.5714%; order: 0"
            >
              <div
                class="flex-column flex-wrap cursor-pointer shimmer-container rounded"
                style="height: 80px; width: 80px"
              >
              </div>
            </li>
            <li
              class="carousel__slide carousel__slide--active carousel__slide--visible"
              style="width: 28.5714%; order: 1"
            >
              <div
                class="flex-column flex-wrap cursor-pointer shimmer-container rounded"
                style="height: 80px; width: 80px"
              >
              </div>
            </li>
            <li
              class="carousel__slide carousel__slide--visible"
              style="width: 28.5714%; order: 2"
            >
              <div
                class="flex-column flex-wrap cursor-pointer shimmer-container rounded"
                style="height: 80px; width: 80px"
              >
              </div>
            </li>
            <li
              class="carousel__slide carousel__slide--next"
              style="width: 28.5714%; order: 3"
            >
              <div
                class="flex-column flex-wrap cursor-pointer shimmer-container rounded"
                style="height: 80px; width: 80px"
              >
              </div>
            </li>
            <li class="carousel__slide" style="width: 28.5714%; order: 4">
              <div
                class="flex-column flex-wrap cursor-pointer shimmer-container rounded"
                style="height: 80px; width: 80px"
              >
              </div>
            </li>
          </ol>
        </div>
      </section>
    </div>
    <div class="order-filters col-sm-12 flex-row align-items-start">
      <div
        class="order-filter-item flex-row fs-12 lh-18 pd8 ml3 mr3 shimmer-container"
        style="min-width: 85px; border: none"
      ></div>
      <div
        class="order-filter-item flex-row fs-12 lh-18 pd8 ml3 mr3 shimmer-container"
        style="min-width: 85px; border: none"
      ></div>
      <div
        class="order-filter-item flex-row fs-12 lh-18 pd8 ml3 mr3 shimmer-container"
        style="min-width: 85px; border: none"
      ></div>
    </div>
    <div class="horizontal-product-main mb32" id="recommendedItems">
      <div
        class="card-catg-name shimmer-container rounded"
        style="min-width: 210px; min-height: 20px"
      >
        <!-- <h3>Recommended</h3> -->
      </div>
      <div class="observer"></div>
      <section class="carousel" dir="ltr" aria-label="Gallery">
        <div class="carousel__viewport mt12 ml12">
          <ol
            class="carousel__track"
            style="transform: translateX(0px); transition: all 0ms ease 0s"
          >
            <li
              class="carousel__slide carousel__slide--active carousel__slide--visible shimmer-container rounded"
              style="width: 92.5926%; order: 0; height: 300px"
            ></li>
            <li
              class="carousel__slide carousel__slide--next shimmer-container rounded"
              style="width: 92.5926%; order: 1; height: 300px"
            ></li>
            <li
              class="carousel__slide shimmer-container rounded"
              style="width: 92.5926%; order: 2; height: 300px"
            ></li>
            <li
              class="carousel__slide shimmer-container rounded"
              style="width: 92.5926%; order: 3; height: 300px"
            ></li>
            <li
              class="carousel__slide shimmer-container rounded"
              style="width: 92.5926%; order: 4; height: 300px"
            ></li>
            <li
              class="carousel__slide shimmer-container rounded"
              style="width: 92.5926%; order: 5; height: 300px"
            ></li>
            <li
              class="carousel__slide shimmer-container rounded"
              style="width: 92.5926%; order: 6; height: 300px"
            ></li>
            <li
              class="carousel__slide shimmer-container rounded"
              style="width: 92.5926%; order: 7; height: 300px"
            ></li>
            <li
              class="carousel__slide shimmer-container rounded"
              style="width: 92.5926%; order: 8; height: 300px"
            ></li>
            <li
              class="carousel__slide shimmer-container rounded"
              style="width: 92.5926%; order: 9; height: 300px"
            ></li>
            <li
              class="carousel__slide shimmer-container rounded"
              style="width: 92.5926%; order: 10; height: 300px"
            ></li>
            <li
              class="carousel__slide shimmer-container rounded"
              style="width: 92.5926%; order: 11; height: 300px"
            ></li>
            <li
              class="carousel__slide shimmer-container rounded"
              style="width: 92.5926%; order: 12; height: 300px"
            ></li>
          </ol>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  name: "Shimmer",

  components: {},

  props: [],

  setup(props) {
    return {};
  },
};
</script>
